import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Button, Breadcrumb, Modal } from 'antd'
import { getHeaders, adminUsersUrl } from '../../config'
import Update from './Update'
import PageLoader from '../../components/Layouts/PageLoader'
import PageTitle from 'components/PageTitle'

const Detail = props => {
  const [customer, setCustomer] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: ''
  })

  // eslint-disable-next-line
  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const getCustomer = () => {
    setLoading(true)
    axios
      // eslint-disable-next-line react/prop-types
      .get(adminUsersUrl + '/' + props.match.params.id, {
        headers: getHeaders()
      })
      .then(res => {
        setLoading(false)
        setCustomer(res.data)
      })
      .catch(() => {
        setLoading(false)
        console.log('error')
      })
  }

  useEffect(() => {
    getCustomer()
    // eslint-disable-next-line
  }, [])

  return (
    <PageLoader className="container" loading={loading}>
      <PageTitle title="Customer details" />
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/customers">Our Customers</Breadcrumb.Item>
            <Breadcrumb.Item>Customer Details</Breadcrumb.Item>
          </Breadcrumb>
          <br />
          <br />
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="card mb-4rem">
                <div className="card-header">Customer Details</div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>First Name</b>
                      </div>{' '}
                      {customer.firstName}
                    </div>

                    <div className="col-md-5 offset-md-2 mb-2rem">
                      <div>
                        <b>Last Name</b>
                      </div>
                      {customer.lastName}
                    </div>

                    <div className="col-md-5 mb-2rem">
                      <div>
                        <b>Phone Number</b>
                      </div>
                      {customer.phoneNumber}
                    </div>

                    <div className="col-md-5 offset-md-2 mb-2rem">
                      <div>
                        <b>Email</b>
                      </div>
                      {customer.email}
                    </div>

                    <div className="col-md-12 pull-right">
                      <div>
                        <Button
                          type="primary"
                          ghost
                          onClick={() => {
                            setShowModal(true)
                          }}
                          loading={loading}
                        >
                          Update
                        </Button>
                      </div>
                    </div>

                    <Modal
                      title="Update Customer Details"
                      centered
                      open={showModal}
                      onOk={() => setShowModal(false)}
                      onCancel={() => setShowModal(false)}
                      footer={null}
                      width={1000}
                    >
                      <Update
                        customer={customer}
                        handleCancel={() => {
                          setShowModal(false)
                          getCustomer()
                        }}
                      />
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLoader>
  )
}

export default Detail
